import { Colors } from './colors'
import { Sizes } from './tokens'

export const FontsClasses = {
  P2: `font-roboto text-[14px] leading-[22px]`,
}

export const Fonts = {
  H0: {
    fontFamily: `'Rubik', sans-serif`,
    fontSize: Sizes[26],
    lineHeight: '36px',
  },
  H1: {
    fontFamily: `'Rubik', sans-serif`,
    fontSize: Sizes[20],
    lineHeight: '30px',
  },
  H2: {
    fontFamily: `'Rubik', sans-serif`,
    fontSize: Sizes[16],
    lineHeight: '26px',
  },
  H3: {
    fontFamily: `'Rubik', sans-serif`,
    fontSize: Sizes[14],
    lineHeight: '22px',
  },
  P0: {
    fontFamily: `'Roboto', sans-serif`,
    fontSize: Sizes[18],
    lineHeight: '30px',
  },
  P1: {
    fontFamily: `'Roboto', sans-serif`,
    fontSize: Sizes[16],
    lineHeight: '26px',
  },
  P2: {
    fontFamily: `'Roboto', sans-serif`,
    fontSize: Sizes[14],
    lineHeight: '22px',
  },
  P3: {
    fontFamily: `'Roboto', sans-serif`,
    fontSize: Sizes[12],
    lineHeight: '20px',
  },
  Mono: {
    fontFamily: `'Inconsolata', monospace`,
    fontSize: Sizes[16],
    lineHeight: '26px',
  },
  MonoSmall: {
    fontFamily: `'Inconsolata', monospace`,
    fontSize: Sizes[14],
    lineHeight: '22px',
  },
  colors: {
    White: {
      color: Colors.White,
    },
    Jet: {
      color: Colors.Jet,
    },
    Hurricane: {
      color: Colors.Hurricane,
    },
    SlateGrey: {
      color: Colors.SlateGrey,
    },
    King: {
      color: Colors.King,
    },
    Alert: {
      color: Colors.Alert,
    },
    Warning: {
      color: Colors.Warning,
    },
    Cobalt: {
      color: Colors.Cobalt,
    },
    Navy: {
      color: Colors.Navy,
    },
    Topaze: {
      color: Colors.Topaze,
    },
    Silver: {
      color: Colors.Silver,
    },
    Ash: {
      color: Colors.Ash,
    },
    Ink: {
      color: Colors.Ink,
    },
  },
} as const
